import { WarningFilled } from '@ant-design/icons'
import { useFormatter } from '@api/useFormatter'
import { usePayroll } from '@api/usePayroll'
import { AutomaticPayItems } from '@components/DriverManagement/Payroll/PayrollReportExpand/AutomaticPay'
import { SpecialPayItems } from '@components/DriverManagement/Payroll/PayrollReportExpand/SpecialPay'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Spin } from 'antd'
import moment from 'moment'
import React from 'react'

export function PayrollRowExpand({ data, startDate, triggerRefresh }) {
  const { usePayrollExpandQuery } = usePayroll()
  const { data: detail, isFetching } = usePayrollExpandQuery(moment.utc(startDate).toISOString(), data.driver_id)

  if (isFetching)
    return (
      <div className='center-flex-container p-5'>
        <Spin />
      </div>
    )

  return (
    <div className='payroll-detail'>
      {detail?.has_errors && <DetailErrors detail={detail} />}
      <div className='flex' style={{ alignItems: 'stretch' }}>
        <AutomaticPayItems detail={detail} />
        <SpecialPayItems
          driver={data}
          detail={detail}
          startDate={startDate}
          driverId={data.driver_id}
          triggerRefresh={triggerRefresh}
        />
      </div>
    </div>
  )
}

function DetailErrors({ detail }) {
  const { formatVolume } = useFormatter()
  const formattedVolume = formatVolume(null, false)
  return (
    <Horizontal verticalCenter className=' p-3' style={{ background: 'var(--theme-error-dim' }}>
      <Texto weight='bold' appearance='error'>
        PAYROLL ERRORS
      </Texto>

      <div className='flex-1 flex justify-end ' style={{ gap: 10, flexWrap: 'wrap' }}>
        {detail.errors.map((e, i) => {
          const formattedError = e.replace(/volume/g, formattedVolume)
          return (
            <Texto weight={600} appearance='error' className='ml-3' key={i}>
              <WarningFilled className='pr-2' /> {formattedError}
            </Texto>
          )
        })}
      </div>
    </Horizontal>
  )
}
